import { useEffect, useState } from 'react'

const getItemsPerPage = (viewMode) => {
  const containerWidth = window.innerWidth * 0.9

  if (viewMode === 'cards') {
    const cardsPerRow = Math.floor(containerWidth / 280)
    return Math.max(1, cardsPerRow * 2)
  }

  if (viewMode === 'table') {
    return 8
  }

  return 8
}
export default function usePagination(view) {
  const [currentPage, setCurrentPage] = useState(1)
  const [itemsPerPage, setItemsPerPage] = useState(getItemsPerPage(view))

  useEffect(() => {
    const updateItemsPerPage = () => setItemsPerPage(getItemsPerPage(view))

    window.addEventListener('resize', updateItemsPerPage)

    updateItemsPerPage()

    return () => window.removeEventListener('resize', updateItemsPerPage)
  }, [view])

  return {
    currentPage,
    itemsPerPage,
    goToNextPage: (totalPages) => setCurrentPage((p) => Math.min(p + 1, totalPages)),
    goToPreviousPage: () => setCurrentPage((p) => Math.max(p - 1, 1)),
    setCurrentPage,
  }
}
